const BOOKING_STATUS_ARCHIVED = 'ARCHIVED';
const BOOKING_STATUS_BOOKMARK = 'BOOKMARK';
const BOOKING_STATUS_CANCELED = 'CANCELED';
const BOOKING_STATUS_EXPIRED_HOPE = 'EXPIRED_HOPE';
const BOOKING_STATUS_EXPIRED_OPTION = 'EXPIRED';
const BOOKING_STATUS_EXPIRED_QUOTATION = 'EXPIRED_QUOTATION';
const BOOKING_STATUS_HOPE = 'HOPE';
const BOOKING_STATUS_OPTION = 'OPTION';
const BOOKING_STATUS_QUOTATION = 'QUOTATION';
const BOOKING_STATUS_REQUEST = 'REQUEST';
const BOOKING_STATUS_SEARCH = 'SEARCH';
const BOOKING_STATUS_VALIDATED = 'VALIDATED';
export {
  BOOKING_STATUS_ARCHIVED,
  BOOKING_STATUS_BOOKMARK,
  BOOKING_STATUS_CANCELED,
  BOOKING_STATUS_EXPIRED_HOPE,
  BOOKING_STATUS_EXPIRED_OPTION,
  BOOKING_STATUS_EXPIRED_QUOTATION,
  BOOKING_STATUS_HOPE,
  BOOKING_STATUS_OPTION,
  BOOKING_STATUS_QUOTATION,
  BOOKING_STATUS_REQUEST,
  BOOKING_STATUS_SEARCH,
  BOOKING_STATUS_VALIDATED,
};
